/**
 *
 */
export const config = {
  API_URL : "http://google.fr"
}

// merge with env
Object.assign(config, window["config"] || {})
